<template>
  <div :id="componentId">
    <b-row>
      <b-colxx xxl="10" xl="10" lg="10" class="px-0">
        <span class="y-axis-label">Participants</span>
        <div class="daily-sensor-compliance-table">
          <div class="rtl-display">
            <div class="daily-sensor-table table-content scroll-bar" ref="test" v-on:scroll="onScrollTable" :style="{ maxHeight: height }">
              <transition name="fade">
                <div v-if="showTableContainer" class="daily-sensor-table Sticky-table-header">
                  <table id="body" v-if="newData != null" class="mt-10 ltr-display">
                    <thead>
                      <tr class="w-auto">
                        <div class="d-flex justify-content-between">
                          <div class="body-participant-brand-column">
                            <th class="body-participant-column participant-column">
                              <div class="body-paticipant-header d-inline-block">
                                Participant
                              </div>
                            </th>
                            <th class="body-brand-column brand-column">
                              <div class="body-brand-header d-inline-block">
                                Brand Name
                              </div>
                            </th>
                          </div>
                          <div class="top-margin">
                            <th class="sensor-boxes-column" v-for="(date, i) in dateAndDayHeaders" :key="i">
                              <div class="sensor-boxes-header">
                                {{ date.displayDate }}
                              </div>
                            </th>
                          </div>
                          <div class="participant-last-logged-compliance-column">
                            <th class="participant-details-header">
                              <div class="body-logged-header d-inline-block">
                                Last Logged
                              </div>
                            </th>
                            <th class="participant-details-header">
                              <div class="body-compliance-header d-inline-block">
                                <span>Compliance</span>
                              </div>
                            </th>
                          </div>
                        </div>
                      </tr>
                    </thead>
                    <tbody id="table-body-boxes" class="table-body-boxes">
                      <tr :id="snakeCasess(generateParticipantsId(r.participants))" v-for="r in newData" :key="generateParticipantsId(r.participants)" class="w-auto">
                        <div class="d-flex justify-content-between">
                          <div class="body-participant-brand-column">
                            <!-- Participant name column -->
                            <th
                              class="
                                body-participant-column
                                participant-column participant-value
                              "
                            >
                              <div
                                class="
                                  add-tooltip
                                  body-participant-value
                                  d-inline-block
                                "
                              >
                                {{ getFormattedParticipantName(r) }}
                              </div>
                              <div
                                class="
                                  custom-tooltip
                                  hidden-text-custom
                                  m-0
                                  custom-tooltip-padding
                                "
                              >
                                {{ r.participantNames }}
                              </div>
                            </th>
                            <th class="body-brand-column brand-column brand-value">
                              <div
                                class="
                                  add-tooltip
                                  brand-value-name
                                  d-inline-block
                                  text-capitalize
                                "
                              >
                                {{ getFormattedBrandedName(r) }}
                              </div>
                              <div
                                class="
                                  custom-tooltip
                                  hidden-text-custom
                                  m-0
                                  custom-tooltipbeansname
                                  text-capitalize
                                "
                              >
                                {{ r.brandNames }}
                              </div>
                            </th>
                          </div>
                          <!-- Completion boxes matrix -->
                          <div>
                            <td class="sensor-details" v-for="(c, i) in r.matrixActivities" :key="i" :id="snakeCasess(generateParticipantsId(r.participants) + c.brand + c.loggedDate)">
                              <div class="sensor-detail-boxes">
                                <!-- Status box -->
                                <div
                                  :class="c.classLabel + ' daily-sensor-tooltip sensor-item-anim' + (!activeLegend.includes(c.status) && ' daily-sensor-inactive')"
                                  @mouseover="c.status !== 'Not Started' && activeLegend.includes(c.status) && showTooltip(c, snakeCasess(generateParticipantsId(r.participants) + c.brand + c.loggedDate))"
                                  @mouseout="hideTooltip(snakeCasess(generateParticipantsId(r.participants) + c.brand + c.loggedDate))"
                                ></div>
                              </div>
                            </td>
                          </div>
                          <div class="participant-last-logged-compliance-column">
                            <!-- Completion percentage column -->
                            <td class="participant-details-header">
                              <div
                                class="
                                  add-tooltip
                                  body-logged-value
                                  text-truncate
                                  d-inline-block
                                "
                              >
                                {{ r.lastlogdate }}
                              </div>
                            </td>
                            <td class="participant-details-header">
                              <div
                                class="
                                  add-tooltip
                                  body-percentage-value
                                  text-truncate
                                  d-inline-block
                                "
                              >
                                <span>{{ r.totalPercentageCompleted }}%</span>
                              </div>
                            </td>
                          </div>
                        </div>
                      </tr>
                    </tbody>
                  </table>
                  <span id="sensor-tooltips"></span>
                </div>
              </transition>
            </div>
          </div>
        </div>
        <span class="x-axis-label">Date</span>
      </b-colxx>
      <div class="d-flex flex-column justify-content-center p-0 pl-30">
        <div class="mb-2">
          <span
            id="Compliant"
            @click="handleLegend('Compliant')"
            :class="{
              'daily-sensor-inactive': !activeLegend.includes('Compliant')
            }"
            class="
              cursor_pointer
              daily-sensor-legend-compliant daily-sensor-tooltip
            "
          >
          </span>
          <span class="daily-sensor-legend-text">Compliant</span>
        </div>
        <div class="mb-2">
          <span
            id="NonCompliant"
            @click="handleLegend('Non Compliant')"
            :class="{
              'daily-sensor-inactive': !activeLegend.includes('Non Compliant')
            }"
            class="
              cursor_pointer
              daily-sensor-legend-noncompliant daily-sensor-tooltip
            "
          >
          </span>
          <span class="daily-sensor-legend-text">Non-Compliant</span>
        </div>
        <div class="mb-2">
          <span
            id="NotStarted"
            @click="handleLegend('Not Started')"
            :class="{
              'daily-sensor-inactive': !activeLegend.includes('Not Started')
            }"
            class="
              cursor_pointer
              daily-sensor-legend-notstarted daily-sensor-tooltip
            "
          >
          </span>
          <span class="daily-sensor-legend-text">Not Started</span>
        </div>
      </div>
    </b-row>
  </div>
</template>

<script>
import { getContrastTextColor } from "../../services/visualization/utils";
import _ from "lodash";

export default {
  props: {
    matrixData: [Array, null],
    height: String,
    dateAndDayHeaders: [Array, null]
  },
  data() {
    return {
      componentId: "daily-sensor-compliance-body",
      newData: [],
      showTableContainer: false,
      activeLegend: ["Compliant", "Non Compliant", "Not Started"],
      getContrastTextColor: getContrastTextColor,
      prevVerticalScroll: 0,
      prevHorizontalScroll: 0
    };
  },
  watch: {
    matrixData: {
      deep: true,
      handler(value) {
        this.newData = value;
        this.render();
      }
    }
  },
  methods: {
    handleLegend(status) {
      const tempArr = [];
      if (this.activeLegend.length === 1 && this.activeLegend[0] === status) {
        tempArr.push("Compliant", "Non Compliant", "Not Started");
      } else {
        tempArr.push(status);
      }
      this.activeLegend = tempArr;
    },
    getFormattedParticipantName(r) {
      return r.participantNames.split("").length < 13
        ? r.participantNames
        : r.participantNames
            .split("")
            .splice(0, 13)
            .join("") + "...";
    },
    getFormattedBrandedName(r) {
      return r.brandNames.split("").length < 17
        ? r.brandNames
        : r.brandNames
            .split("")
            .splice(0, 17)
            .join("") + "...";
    },
    onScrollTable() {
      const verticalScrollPosition = this.$refs.test.clientHeight + this.$refs.test.scrollTop;
      if (this.$refs.test.scrollTop !== 0 && verticalScrollPosition > this.$refs.test.scrollHeight - 1 && verticalScrollPosition > this.prevVerticalScroll) {
        this.prevVerticalScroll = verticalScrollPosition;
        this.$emit("onScrollTable", "vertical");
        this.$refs.test.scrollTop = this.$refs.test.scrollHeight - this.$refs.test.clientHeight;
      }

      const horizontalScrollPosition = this.$refs.test.scrollWidth - (Math.abs(this.$refs.test.scrollLeft) + this.$refs.test.clientWidth);
      const horizontalScrollBoundary = this.$refs.test.scrollWidth - this.$refs.test.clientWidth - 1;
      if (horizontalScrollPosition !== 0 && horizontalScrollPosition >= horizontalScrollBoundary && horizontalScrollPosition > this.prevHorizontalScroll) {
        this.prevHorizontalScroll = horizontalScrollPosition;
        this.$emit("onScrollTable", "horizontal");
      }
    },
    render() {
      setTimeout(() => {
        this.showTableContainer = true;
        // Then animate percents
        setTimeout(() => {
          document.querySelector(".daily-sensor-table").scrollLeft += document.querySelector(".daily-sensor-table").offsetWidth;
          document.querySelector(".daily-sensor-table").scrollLeft -= 5;
        }, 100);
      }, 100);
    },
    snakeCasess(text) {
      return _.snakeCase(text);
    },
    generateParticipantsId(participant) {
      return participant;
    },

    showTooltip(data, elementId) {
      let element = null;
      let tableElement = null;
      let tooltips = null;

      const hexColors = this.setColor(data.statusTooltip);
      const bodyStyles = document.body.style;
      bodyStyles.setProperty("--study-hex-color", hexColors);

      tableElement = document.getElementById("table-body-boxes");
      if (elementId) {
        element = document.getElementById(elementId);
      }

      tooltips = document.getElementById("sensor-tooltips");

      const dailySensorElementTooltips = element.getBoundingClientRect();
      const dailySensorTable = tableElement.getBoundingClientRect();
      const sensorTooltip = tooltips.getBoundingClientRect();

      if (dailySensorTable.y > dailySensorElementTooltips.y) {
        tooltips.style.bottom = dailySensorElementTooltips.top - 80 + "px";
      } else {
        if (dailySensorElementTooltips.top - 80 > 0) {
          tooltips.style.top = dailySensorElementTooltips.top - 80 + "px";
        } else {
          tooltips.style.top = 49 + "px";
        }
      }

      tooltips.style.direction = "ltr";
      tooltips.style.position = "fixed";
      tooltips.style.visibility = "visible";
      tooltips.style.borderRadius = "4px";
      tooltips.style.backgroundColor = hexColors;
      tooltips.style.color = getContrastTextColor(hexColors);
      tooltips.style.zIndex = 100000000000000;
      tooltips.style.padding = "5px";
      tooltips.style.fontSize = "10px";
      tooltips.style.cursor = "pointer";
      tooltips.style.pointerEvents = "none";
      tooltips.style.fontFamily = "Roboto-Regular";
      tooltips.style.flexGrow = 0;
      tooltips.style.fontStretch = "normal";
      tooltips.style.fontStyle = "normal";
      tooltips.style.letterSpacing = "normal";
      tooltips.style.lineHeight = "1.5";

      tooltips.innerHTML = `
        <span class="sensor-date">${data.loggedDate}</span>
        <span class="sensor-date-value">(Day ${data.loggedDay})</span><br/>
        <span class="sensor-date-participant">Participant:</span> 
        <span class="sensor-date-participant-value">${data.participants}</span><br/>
        <span class="sensor-date-brand">Brand Name:</span>
        <span class="sensor-date-brand-value text-capitalize">${data.brand}</span><br/>
        <span class="sensor-date-data-logs"># of Data Logs:</span>
        <span class="sensor-date-data-logs-value">${data.numberOfTimesDataLogged}</span><br/>
      `;
      const halfWidth = dailySensorElementTooltips.width / 2;
      const halfTooltipWidth = tooltips.getBoundingClientRect().width / 2;

      if (sensorTooltip.width === 0) {
        tooltips.style.left = dailySensorElementTooltips.x + halfWidth - halfTooltipWidth + "px";
      }

      setTimeout(() => {
        tooltips.style.left = dailySensorElementTooltips.x + halfWidth - halfTooltipWidth + "px";
      }, 1);
    },
    setColor(classlabel = "") {
      let tmpColor = "";
      switch (classlabel) {
        case "daily-sensor-tooltip-compliant":
          tmpColor = "#dcefe6";
          break;
        case "daily-sensor-tooltip-noncompliant":
          tmpColor = "#fedddd";
          break;
        case "daily-sensor-tooltip-notstarted":
          tmpColor = "#ffffff";
          break;
        default:
          break;
      }

      return tmpColor;
    },
    hideTooltip() {
      const tooltips = document.getElementById("sensor-tooltips");
      tooltips.style.visibility = "hidden";
    }
  },
  async mounted() {
    this.newData = this.matrixData;
    this.render();
  }
};
</script>

<style lang="scss" scoped>
.daily-sensor-tooltip {
  border-bottom: transparent;
  z-index: 1;
}

.daily-sensor-box-notstarted {
  height: 100%;
  width: 100%;
  background-color: #d3d3d3;
}

.daily-sensor-legend-compliant {
  background-color: #83c6a8;
  float: left;
  position: relative;
  width: 15px;
  height: 15px;
  margin-left: 6px;
  margin-right: 6px;
}

.daily-sensor-legend-noncompliant {
  background-color: #fb9a99;
  float: left;
  position: relative;
  width: 15px;
  height: 15px;
  margin-left: 6px;
  margin-right: 6px;
}

.daily-sensor-legend-notstarted {
  background-color: #d3d3d3;
  float: left;
  position: relative;
  width: 15px;
  height: 15px;
  margin-left: 6px;
  margin-right: 6px;
}

.daily-sensor-box-compliant {
  height: 100%;
  width: 100%;
  background-color: #83c6a8;
}

.daily-sensor-box-noncompliant {
  height: 100%;
  width: 100%;
  background-color: #fb9a99;
}

#sensor-tooltips::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  border-width: 7px;
  margin-left: -5px;
  border-style: solid;
  border-color: var(--study-hex-color) transparent transparent transparent;
}

.daily-sensor-tooltip {
  z-index: 0;
}

.body-brand-header {
  height: 12px !important;
}

.body-participant-value {
  height: 12px !important;
}

.body-paticipant-header {
  height: 12px !important;
}

.body-percentage-value {
  height: 12px !important;
}

.custom-tooltip:after {
  content: " ";
  position: unset;
  top: 0;
  right: 0;
  margin-top: 0;
  border-width: 0;
  border-style: unset;
  border: none;
  border-right-color: unset;
  left: 0;
}
.custom-tooltipbeansname {
  left: 7rem !important;
}
.custom-tooltip-padding {
  left: 5.5rem !important;
}
.custom-tooltip:before {
  content: " ";
  position: unset;
  top: 0;
  right: 0;
  margin-top: 0;
  border: none;
  border-right-color: unset;
  left: 0;
}

.custom-tooltip {
  left: 2.5rem;
  top: -3px;
  width: max-content;
}

.y-axis-label {
  font-style: "Roboto-Medium" !important;
  transform: translateX(-50%) translateY(-50%) rotate(-90deg);
  position: absolute;
  top: 50%;
  color: #959fa4;
  font-size: 10px;
}

.x-axis-label {
  font-style: "Roboto-Medium" !important;
  transform: translateX(-50%) translateY(-50%) !important;
  position: absolute;
  left: 50%;
  bottom: -30px;
  font-size: 10px;
  color: #959fa4;
}

.rtl-display {
  width: 100%;
  display: block;
  direction: rtl;
  padding-top: 1px;
}

.ltr-display {
  width: 100%;
  direction: ltr;
}

.table-content {
  overflow-y: auto;
  overflow-x: auto;
  height: max-content;
  margin-left: 10px;
}

.table-body-boxes {
  width: 100%;
  padding-bottom: 1px;
  padding-top: 1px;
}

.body-brand-column {
  position: sticky;
  left: 70px;
  padding-left: 5px;
  height: 11px;
  background-color: white;
  width: 105px !important;
  text-align: right !important;
}

.top-margin {
  margin-top: 7.6px;
}

.body-participant-column {
  position: sticky;
  left: -10.5px;
  width: 5%;
  padding-left: 15.5px;
  height: 11px;
  background-color: white;
}

.w-auto {
  width: auto;
}

.sensor-details {
  padding: 0;
  padding-left: 5px;
  width: 1px;
  overflow: hidden;
}

.sensor-boxes-column {
  height: 11px;
  padding: 0;
  padding-left: 5px;
  width: 1px;
  overflow: hidden;
}

.sensor-detail-boxes {
  height: 25px;
  width: 40px;
}

.sensor-boxes-header {
  height: 11px;
  width: 40px;
  flex-grow: 0;
  font-family: Roboto-Medium;
  font-size: 9px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  text-align: center;
  color: #959fa4;
}

.participant-value {
  position: sticky;
  right: 0;
  z-index: 11;
}

.body-participant-brand-column {
  position: sticky;
  left: -30px;
  z-index: 1;
  background-color: #fff;
}

.brand-value {
  position: sticky;
  right: 0;
  z-index: 10;
}

.participant-last-logged-compliance-column {
  position: sticky;
  right: -1px;
  background-color: #fff;
}

.participant-details-header {
  height: 11px;
  width: 40px;
  min-width: 40px;
  background-color: white;
  text-align: left;
  padding-left: 10px;
  z-index: 14;
}

.sensor-item-anim:hover {
  border: none !important;
  box-shadow: unset !important;
}

.scroll-bar {
  &::-webkit-scrollbar {
    width: 11px;
    height: 11px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #b0bac9;
    border-radius: 10px;
    border: 2px solid #e2e7ea;
  }

  &::-webkit-scrollbar-track {
    background-color: #e2e7ea;
    margin-top: 35px;
  }
}
</style>
